// extracted by mini-css-extract-plugin
export default {"sidebar":"SidebarAdmin_sidebar__QatWc","sidebar--narrow":"SidebarAdmin_sidebar--narrow__iPW6W","sidebar__header-links":"SidebarAdmin_sidebar__header-links__3GV7b"};